//https://imagekit.io/blog/how-to-resize-image-in-javascript/
import React, {memo} from 'react';
import {Button, Col, Row} from "react-bootstrap";
import {getToken} from "../../Utils/Common";
import "jspdf-autotable"
import "./Calibri-normal";

import {faBuilding, faCheck, faEnvelope, faFilePdf} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment";


function TagesButtonComponent(props) {

    async function saveData(status) {
        let apiBody = {}
        apiBody.status = status
        apiBody.report = props.maintatigdataarray
        apiBody.creatorFirstName = "TestFN"
        apiBody.creatorLastName = "TestLN"
        apiBody.organisationID = props.orgID
        apiBody.projectID = props.projectID
        apiBody.tagesComponents = props.tagesComponents

        let result = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/saveTagesReport", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify(
                {
                    token: getToken(),
                    data: apiBody
                }),
        }).then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
        if (result.status === 200) {
            props.setAcceptState(true)
            props.setTagesState(status)
            props.setMetaID(result.metaID)
        }
        alert(result.message)
    }


    async function handleExportClick() {
        await props.createTReport({
            type: "downloadPDF",
            anschrift: props.pdfAddress
        });
    }

    return (

        <Row className="justify-content-between">
            <Col style={{
                className: "col-md-4",
                textAlign: "left", paddingRight: 0
            }}>
                <Button
                    disabled={props.disablePDFButton||props.reportViewWithoutLogin || props.tagesState === "Akzeptiert"}
                    title="Akzeptiert"
                    className="handwai-btn-create ml-5 mr-4"
                    onClick={async () => {
                        await saveData("Akzeptiert")
                    }}
                >
                    <FontAwesomeIcon icon={faCheck}/>
                </Button>

                <Button
                    disabled={props.disablePDFButton||props.reportViewWithoutLogin || props.tagesState === "Intern" || props.tagesState === "Akzeptiert"}
                    title="Intern"
                    className="handwai-btn-create"
                    onClick={async () => {
                        await saveData("Intern")
                    }}
                >
                    <FontAwesomeIcon icon={faBuilding}/>
                </Button>


            </Col>
            {props.disablePDFButton||props.tagesState === "Akzeptiert" && !props.reportViewWithoutLogin &&
            <Col style={{className: "col-md-4", textAlign: "center"}}>
                <Button
                    title="Email"
                    onClick={() => {
                        let entscheidungsbefugt=[]
                        props.auftraggeberList.forEach((j) => {
                            if (j.entscheidungsbefugnis){
                                entscheidungsbefugt.push({
                                    value:j.email,
                                    label:j.email})
                            }
                        })

                        props.setReportDetails({
                                attachmentName: moment().format("YYYYMMDD") + "_TAG_" + props.projectData.projectName,
                                emailToAddress: entscheidungsbefugt,
                                reportToRole: "Planer",
                                toFirstName: "FN",
                                toLastName: "LN"
                            }
                        )
                        props.setHandleShow(true)
                    }
                    }
                    className="handwai-btn-create ml-5 mr-4"
                >
                    <FontAwesomeIcon icon={faEnvelope}/>
                </Button>
            </Col>
            }
            <Col style={{
                className: "col-md-4",
                textAlign: "right", paddingRight: 0
            }}>
                <Button
                    disabled={props.disablePDFButton||props.tagesState !== "Akzeptiert"}
                    onClick={async () => {
                        handleExportClick()
                    }}
                    className="handwai-btn-create mr-4"
                    variant="success"
                >
                    <FontAwesomeIcon icon={faFilePdf}/>
                </Button>
            </Col>

        </Row>

    );
}

export default memo(TagesButtonComponent);